'use client';

import _formatErrorMessage from "@mui/x-internals/formatErrorMessage";
import * as React from 'react';
export const TimelineGridEventContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== "production") TimelineGridEventContext.displayName = "TimelineGridEventContext";
export function useTimelineGridEventContext() {
  const context = React.useContext(TimelineGridEventContext);
  if (context === undefined) {
    throw new Error(process.env.NODE_ENV !== "production" ? 'MUI X Scheduler: `TimelineGridEventContext` is missing. TimelineGrid Event parts must be placed within <TimelineGrid.Event />.' : _formatErrorMessage(265));
  }
  return context;
}